var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _g4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _path3, _path4, _path5, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlock3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 203,
    viewBox: "0 0 393 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    width: 44,
    height: 62,
    rx: 4,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 6,
    width: 32,
    height: 26,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 38,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 46,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 54,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 173,
    y: 117,
    width: 66,
    height: 86,
    rx: 4,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 123,
    width: 24,
    height: 25,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 123,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 131,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 139,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 147,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 155,
    width: 54,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 163,
    width: 54,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 171,
    width: 54,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 179,
    width: 54,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 187,
    width: 54,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 195,
    width: 42,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    y: 102,
    width: 66,
    height: 39,
    rx: 4,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 108,
    width: 24,
    height: 27,
    rx: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 108,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 116,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 124,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 132,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 38,
    y: 12,
    width: 44,
    height: 38,
    rx: 4,
    fill: "#E9E9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 44,
    y: 26,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 44,
    y: 34,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 44,
    y: 42,
    width: 24,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 101,
    width: 44,
    height: 78,
    rx: 4,
    fill: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 147,
    width: 32,
    height: 26,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 107,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 115,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 123,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 131,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354,
    y: 139,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 311,
    y: 7,
    width: 82,
    height: 46,
    rx: 4,
    fill: "#E9E9E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 317,
    y: 29,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 355,
    y: 29,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 317,
    y: 37,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 355,
    y: 37,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 317,
    y: 45,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 355,
    y: 45,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9381 32C89.446 35.9463 86.0796 39 82 39C77.5817 39 74 35.4183 74 31C74 26.5817 77.5817 23 82 23C86.0796 23 89.446 26.0537 89.9381 30H182.062C182.554 26.0537 185.92 23 190 23C194.08 23 197.446 26.0537 197.938 30H301.062C301.554 26.0537 304.92 23 309 23C313.418 23 317 26.5817 317 31C317 35.4183 313.418 39 309 39C304.92 39 301.554 35.9463 301.062 32H197.938C197.446 35.9463 194.08 39 190 39C185.92 39 182.554 35.9463 182.062 32H89.9381Z",
    fill: "#FFF1C0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 148.938C37.9463 148.446 41 145.08 41 141C41 136.582 37.4183 133 33 133C28.5817 133 25 136.582 25 141C25 144.728 27.5495 147.86 31 148.748V151.5C31 158.956 37.0442 165 44.5 165H163.64C164.343 168.701 167.594 171.5 171.5 171.5C175.918 171.5 179.5 167.918 179.5 163.5C179.5 159.082 175.918 155.5 171.5 155.5C167.594 155.5 164.343 158.299 163.64 162H44.5C38.701 162 34 157.299 34 151.5V148.938Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.938 32C247.446 35.9463 244.08 39 240 39C235.582 39 232 35.4183 232 31C232 26.5817 235.582 23 240 23C244.08 23 247.446 26.0537 247.938 30H251.892C261.281 30 268.892 37.6112 268.892 47V57.6815C268.892 65.9658 275.608 72.6815 283.892 72.6815H353C362.389 72.6815 370 80.2926 370 89.6815V93.0619C373.946 93.554 377 96.9204 377 101C377 105.418 373.418 109 369 109C364.582 109 361 105.418 361 101C361 96.9204 364.054 93.554 368 93.0619V89.6815C368 81.3972 361.284 74.6815 353 74.6815H283.892C274.503 74.6815 266.892 67.0703 266.892 57.6815V47C266.892 38.7157 260.176 32 251.892 32H247.938Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356 137C356 141.418 352.418 145 348 145C343.92 145 340.554 141.946 340.062 138H306C299.096 138 293.5 143.596 293.5 150.5C293.5 158.508 287.008 165 279 165H246.938C246.446 168.946 243.08 172 239 172C234.582 172 231 168.418 231 164C231 159.582 234.582 156 239 156C243.08 156 246.446 159.054 246.938 163H279C285.904 163 291.5 157.404 291.5 150.5C291.5 142.492 297.992 136 306 136H340.062C340.554 132.054 343.92 129 348 129C352.418 129 356 132.582 356 137Z",
    fill: "#A8F6D0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 57.9381C64.9463 57.446 68 54.0796 68 50C68 45.5817 64.4183 42 60 42C55.5817 42 52 45.5817 52 50C52 54.0796 55.0537 57.446 59 57.9381V58C59 67.3888 66.6112 75 76 75H137.993C132.641 77.8629 129 83.5062 129 90V102C129 110.284 122.284 117 114 117H73.9381C73.446 113.054 70.0796 110 66 110C61.5817 110 58 113.582 58 118C58 122.418 61.5817 126 66 126C70.0796 126 73.446 122.946 73.9381 119H114C123.389 119 131 111.389 131 102V90C131 81.7157 137.716 75 146 75H178.5H302.062C302.554 78.9463 305.92 82 310 82C314.418 82 318 78.4183 318 74C318 69.5817 314.418 66 310 66C305.92 66 302.554 69.0537 302.062 73H178.5H146H76C67.7157 73 61 66.2843 61 58V57.9381Z",
    fill: "#FFC2BB"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 3,
    width: 201,
    height: 182,
    rx: 5,
    fill: "white",
    stroke: "#E9E9E9",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 43,
    width: 46,
    height: 8,
    rx: 4,
    fill: "#A8F6D0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 59,
    width: 99,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 59,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#FFF1C0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 83,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#FFF1C0"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 107,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#FFF1C0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 59,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E2F2FF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 83,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E2F2FF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 107,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 71,
    width: 99,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 71,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 95,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 245,
    y: 119,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 71,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#FFF1C0"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 95,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#E2F2FF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 119,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 83,
    width: 67,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 95,
    width: 99,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 107,
    width: 99,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 119,
    width: 99,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 131,
    width: 41,
    height: 4,
    rx: 2,
    fill: "#A8F6D0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 57,
    width: 24,
    height: 8,
    rx: 4,
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 69,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 105,
    width: 23,
    height: 8,
    rx: 4,
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 105,
    width: 12,
    height: 8,
    rx: 4,
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 129,
    width: 18,
    height: 8,
    rx: 4,
    fill: "#E2F2FF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlock3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/block3.bc78159d69afbb45c0c596016bcf6d70.svg";